import React from 'react'

import DisplayLine from './DisplayLine'

const DisplayBlock = ({ data }) => (

	<div className="row shadow rounded p-2 m-1">
		{data.displayLines.map((line, index) => (
			<React.Fragment key={index} >
				<DisplayLine
					data={line}
					key={index}
				/>
			</React.Fragment>
		))}
	</div>
)

export default DisplayBlock
